import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import onBreakImage from '../assets/images/on-break.svg';

type OnBreakDialogProps = {
  open: boolean;
  onConfirm: () => void;
};

const OnBreakDialog = ({ open, onConfirm }: OnBreakDialogProps) => {
  const { t } = useTranslation('patient-transport');

  return (
    <Dialog open={open}>
      <DialogTitle>{t('onBreakDialog.title')}</DialogTitle>
      <DialogContent>
        <Stack alignItems="center" spacing={3} textAlign="center">
          <img src={onBreakImage} alt="logout image" />
          <DialogContentText>{t('onBreakDialog.content')}</DialogContentText>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} autoFocus>
          {t('onBreakDialog.leaveBreak')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OnBreakDialog;
